export default __webpack_public_path__ + "static/lutein-spasim-eye-bisect-89c1f6f8350cb7343b57d7741d57074e.jpg";